import React, { useState, useEffect, useContext, useRef } from "react";
import Visualeditor from "../../Components/Visualeditor/Visualeditor";
import { useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import {
  getResumeById,
  sampleResumeById,
} from "../../Store/Actions/ResumeActions";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import Template from "../../Components/CoverTemplates/TemplateOne/TemplateOne";
import { jsonEditorContext } from "../../Context/jsonEditorContext";
import TemplateLoader from "../../TemplateGenerator/TemplateLoader/TemplateLoader";
import { ResumeUpdateContext } from "../../Context/resumeUpdateContext";

import "./preview.scss";
// import "./qr.scss";
function Preview(props) {
  const dispatch = useDispatch();
  const [cover, setCover] = useState(false);
  const [pdfHeight, setPdfHeight] = useState(0);
  const ref = useRef();
  const path = window.location.pathname;

  const {
    json,
    setJson,
    jsonIndex,
    setJsonIndex,
    isJson,
    setIsJson,
    isSample,
  } = useContext(jsonEditorContext);
  const { sectionFocusData, setSectionFocusData } =
    useContext(ResumeUpdateContext);
  const { preview, setPreview } = useContext(ResumePopupContext);
  const { id } = useParams();
  const resume = useSelector((state) => state.resumeGetById);
  const query = new URLSearchParams(window.location.search);
  const share = query.get("share");
  const customizationData = useSelector(
    (state) => state.editorData.customization
  );
  const customStyle = isJson ? json && json.customization : customizationData;

  const url = window.location.pathname;
  const shareUrl = url.split("/");

  useEffect(() => {
    setPreview(true);
    setSectionFocusData("");
  }, []);

  useEffect(() => {
    if (path && path.includes("preview")) {
      document.getElementById("root").style.backgroundColor =
        customStyle && customStyle.colors && customStyle.colors.bgColor;
      document.body.style.backgroundColor =
        customStyle && customStyle.colors && customStyle.colors.bgColor;
    }
  }, [customStyle]);

  useEffect(() => {
    if (
      resume &&
      resume.resume &&
      resume.resume.type &&
      resume.resume.type === "cover_letter"
    ) {
      setCover(true);
    }
  }, [resume]);

  useEffect(() => {
    if (id && id != "") {
      if (props && props.sample) {
      } else {
        if (path.includes("create")) {
          //   dispatch(sampleResumeById(id));
        } else {
          dispatch(getResumeById(id, shareUrl[1]));
        }
      }
    }
  }, [id]);

  const css = `@media print {
	body {
	  background-color: #ffffff !important;
	}
  }`;

  return (
    <>
      {path && path.includes("qr") && <style>{css}</style>}

      <div
        className="preview-body"
        style={{
          //   pointerEvents: "none",
          backgroundColor:
            path && path.includes("preview")
              ? customStyle && customStyle.colors && customStyle.colors.bgColor
              : "unset",
        }}
      >
        {cover && cover ? <Template /> : <TemplateLoader />}
      </div>
    </>
  );
}

export default Preview;
